import { Resource, HateoasResource } from '@lagoshny/ngx-hateoas-client';
@HateoasResource('external-accounts', { routeName: 'customerResourceRoute' })

export class OnPrem extends Resource {
    id: string;
    softwareAccessId: string;
    accountName: string;
    accountType: string;
    secretValue: string;
    selected: boolean;
}
